import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import PostCard from "@/components/feature/PostCard";
import { communityPosts } from "@/mocks/posts";
import { formatCount } from "@/utils/format";

export default function FeaturedSection() {
  const [feature, ...rest] = communityPosts;
  const sidePosts = rest.slice(0, 3);

  return (
    <section className="w-full bg-background-50">
      <div className="max-w-content mx-auto px-4 md:px-8 py-14 md:py-20">
        <SectionHeading
          kicker="Today's Focus"
          title="今日瓜田聚焦"
          desc="每天挑出一条最值得围观的热帖，配上评论区最精彩的那几句。看完正文别急着走，热评才是正文的第二幕。"
          action={
            <Link
              to="/hot"
              className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md border border-foreground-300 text-sm font-medium text-foreground-800 hover:border-primary-400 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              查看全部热帖
              <i className="ri-arrow-right-line"></i>
            </Link>
          }
        />

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-8">
          <div className="lg:col-span-7 flex flex-col">
            <Link
              to={`/post/${feature.id}`}
              className="group flex flex-col h-full bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
            >
              <span className="relative block h-60 md:h-[360px] overflow-hidden">
                <img
                  src={feature.cover}
                  alt={feature.coverAlt}
                  className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
                />
                <span className="absolute top-4 left-4 flex flex-wrap gap-2">
                  <span className="px-3 py-1 rounded-md bg-accent-500 text-background-50 text-xs font-medium">
                    今日置顶
                  </span>
                  <span className="px-3 py-1 rounded-md bg-background-50/95 text-foreground-800 text-xs font-medium">
                    {feature.category}
                  </span>
                </span>
              </span>
              <span className="flex flex-col flex-1 p-5 md:p-7">
                <h3 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors">
                  {feature.title}
                </h3>
                <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                  {feature.summary}
                </p>
                <span className="mt-auto pt-6 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs md:text-sm text-foreground-500">
                  <span className="inline-flex items-center gap-1.5">
                    <span className="w-6 h-6 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center text-[11px] font-medium">
                      {feature.author.slice(0, 1)}
                    </span>
                    {feature.author}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-fire-fill text-primary-500"></i>
                    热度 {formatCount(feature.heat)}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-chat-3-line"></i>
                    {formatCount(feature.replyCount)} 条热评
                  </span>
                </span>
              </span>
            </Link>
          </div>

          <div className="lg:col-span-5 flex flex-col gap-6">
            <div className="bg-background-100 border border-background-200 rounded-lg p-5 md:p-6">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <i className="ri-chat-quote-line text-accent-500"></i>
                今日神回复补录
              </h3>
              <ul className="mt-4 space-y-4">
                {communityPosts.slice(0, 3).map((post) => {
                  const reply = post.replies[0];
                  return (
                    <li key={post.id} className="border-l-2 border-accent-300 pl-4">
                      <p className="text-sm text-foreground-800 leading-relaxed">「{reply.content}」</p>
                      <p className="mt-1.5 text-xs text-foreground-500">
                        {reply.author} · {formatCount(reply.likes)} 赞
                      </p>
                    </li>
                  );
                })}
              </ul>
            </div>

            <div className="bg-background-50 border border-background-200 rounded-lg px-5 md:px-6">
              {sidePosts.map((post, index) => (
                <PostCard key={post.id} post={post} rank={index + 1} variant="compact" />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}